import { render, staticRenderFns } from "./c-another-vuex.vue?vue&type=template&id=58a47790&"
import script from "./c-another-vuex.vue?vue&type=script&lang=ts&"
export * from "./c-another-vuex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports